export { default } from "./TourCard.jsx"
